import React, { useEffect, useState } from "react";
import KycFiles from "./KycFiles";
import { getBusinessDetails } from "../../../services/settings";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/AuthContextProvider";

const ViewDocs = () => {
  const [merchantId, setMerchantId] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessEmail, setBusinessEmail] = useState("");
  const [businessWebAddress, setBusinessWebAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [address, setAddress] = useState("");
  const { globalProfile } = useAuth();

  const handleBusinessDetails = async () => {
    try {
      const res = await getBusinessDetails();
      // setBusinessDetails(res.data);
      setMerchantId(res.data.merchantId); // Update state variables with profileInfo data
      setBusinessName(res.data.businessName);
      setBusinessEmail(res.data.businessEmail);
      setBusinessWebAddress(res.data.webAddress);
      setPhoneNumber(res.data.phoneNumber);
      setAddress(res.data.address);
      setCountry(res.data.country);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    handleBusinessDetails();
  }, [globalProfile]);

  return (
    <div className="mt-5">
      <span className="font-medium text-[25px]">Business Information</span>
      <div className="p-4 w-[50%] flex flex-wrap justify-between gap-3">
        <section className="w-[45%]">
          <div className="font-medium">Business Name</div>
          {businessName}
        </section>

        <section className="w-[45%]">
          <div className="font-medium">Business Email</div>
          {businessEmail}
        </section>

        <section className="w-[45%]">
          <div className="font-medium">Business Web Address</div>
          {businessWebAddress}
        </section>

        <section className="w-[45%]">
          <div className="font-medium">Phone Number</div>
          {phoneNumber}
        </section>

        <section className="w-[45%]">
          <div className="font-medium">Address</div>
          {address}
        </section>

        <section className="w-[45%]">
          <div className="font-medium">Country</div>
          {country}
        </section>
      </div>

      <KycFiles />
    </div>
  );
};

export default ViewDocs;
